import { IMAGE_ACCEPT_ATTRIBUTE } from './constants';

export const pickImageFiles = (): Promise<File[]> =>
	new Promise((resolve) => {
		const input = document.createElement('input');
		input.type = 'file';
		input.accept = IMAGE_ACCEPT_ATTRIBUTE;
		input.multiple = true;
		input.style.display = 'none';

		input.addEventListener('change', () => {
			resolve(Array.from(input.files ?? []));
			input.remove();
		});

		document.body.appendChild(input);
		input.click();
	});
